<div class="coming-soon-wrapper text-center">
    <img src="/assets/images/coming-soon.png" alt="" class="img-fluid">
</div>